import * as React         from 'react';
import { useTranslation } from 'react-i18next';

import './select-installation-type.style.scss';

import { useCatalog } from '../../providers/catalog';

import { RenderBasicTabs } from '../tabs/RenderBasicTabs';

import type { SelectInstallationTypeProps } from './select-installation-type.props';

const SelectInstallationType: React.FC<SelectInstallationTypeProps> = function(props) {
  const { t } = useTranslation();

  const { offer } = props;

  const catalog = useCatalog() as any;

  const changeInstallationType = React.useCallback(() => {
    if (offer) {
      catalog.getOffersByModelAndSeries(
        offer.common.modelId,
        catalog.element.lowPrioritySeriesKey,
        offer.common.offerGroupId,
        offer.common.isInterior,
      );
    }
  }, [catalog.element?.lowPrioritySeriesKey, offer?.common]);

  if (!offer || !catalog.element?.lowPrioritySeriesKey) {
    return null;
  }

  return (
    <div className={'select-installation-type'}>
      <RenderBasicTabs
        active={offer.common.installationTypeUrlKey === 'v-kvartiru' ? 0 : 1}
        changeTab={changeInstallationType}
        nav={[
          { label: t('client_toTheApartment') },
          { label: t('client_toTheHouse') },
        ]}
        useSelect={false}
      />
    </div>
  );
};

export default SelectInstallationType;